export default "/_next/static/images/after-7b9c61c22eaefc58c77a6e9dbdffef4c.png";